<script setup lang="ts">
import { type LayerSpecification, type Map } from "maplibre-gl";
import { computed, onUnmounted } from "vue";
import { coordinatesToFeature } from "./mapUtils";
import type { Area } from "./types";

type FillPaint = Extract<LayerSpecification, { type: "fill" }>["paint"];

const {
  mapInstance,
  area,
  paint = {
    "fill-color": "#2c6c0c",
    "fill-opacity": 0.3,
  },
} = defineProps<{
  mapInstance: Map;
  area: Area;
  paint?: FillPaint;
}>();

const id = computed(() => area.id);

mapInstance.addSource(id.value, {
  type: "geojson",
  data: coordinatesToFeature(area.coordinates),
});
mapInstance.addLayer({
  id: id.value,
  type: "fill",
  source: id.value,
  layout: {},
  paint,
});

onUnmounted(() => {
  if (mapInstance.getLayer(id.value)) mapInstance.removeLayer(id.value);
  if (mapInstance.getSource(id.value)) mapInstance.removeSource(id.value);
});
</script>

<!-- renderless component: logic runs via composables in <script setup> -->
<!-- eslint-disable-next-line vue/valid-template-root -->
<template></template>
